import {FC} from 'react';
import save from '../../../../assets/save.svg';
import {HistoryDownloadProps} from '../../types/balance-history.types';
import {DownloadActions, DownloadButton, InvoiceLink} from './styles';

const DownloadLink: FC<{href?: string; label: string}> = ({href, label}) => {
  if (!href) return null;

  return (
    <InvoiceLink href={href} target="_blank" rel="noreferrer">
      <DownloadButton>
        <img src={save} alt={label} />
        {label}
      </DownloadButton>
    </InvoiceLink>
  );
};

export const HistoryDownload: FC<HistoryDownloadProps> = ({pdfUrl, docUrl}) => {
  return (
    <DownloadActions>
      <DownloadLink href={docUrl} label="doc" />
      <DownloadLink href={pdfUrl} label="pdf" />
    </DownloadActions>
  );
};
